import { HEADER_HEIGHT as GINGER_HEADER_HEIGHT, HEADER_MAX_WIDTH as GINGER_HEADER_MAX_WIDTH, MOBILE_HEADER_HEIGHT as GINGER_MOBILE_HEADER_HEIGHT, MEGA_MENU_Z_INDEX as GINGER_MEGA_MENU_Z_INDEX } from "../../constants/design";
export var MEGA_MENU_Z_INDEX = GINGER_MEGA_MENU_Z_INDEX;
export var HEADER_HEIGHT = GINGER_HEADER_HEIGHT;
export var MOBILE_HEADER_HEIGHT = GINGER_MOBILE_HEADER_HEIGHT;
export var HEADER_MAX_WIDTH = GINGER_HEADER_MAX_WIDTH;
export var MOBILE_CTAS_CONTAINER_HEIGHT = 64;
export var DEBOUNCE_THRESHOLD = 200;
export var MENU_SCROLL_THROTTLE_INTERVAL = 100;
export var TRACKING_THROTTLE_INTERVAL = 700;
export var TOP_MENU_MAX_WIDTH_MOBILE = 498;
export var SUB_MENU_COLUMN_GAP = 144;
export var SUB_MENU_MIN_WIDTH = 220;
export var SUB_MENU_MAX_IMAGE_WIDTH = 256;
export var SUB_MENU_MAX_IMAGE_WIDTH_MOBILE = 328;
export var MegaMenuLinkType;
(function (MegaMenuLinkType) {
  MegaMenuLinkType["Product"] = "Product";
  MegaMenuLinkType["Resource"] = "Resource";
  MegaMenuLinkType["Gallery"] = "Gallery";
})(MegaMenuLinkType || (MegaMenuLinkType = {}));
export var MegaMenuLayout;
(function (MegaMenuLayout) {
  MegaMenuLayout["Columns"] = "Columns";
  MegaMenuLayout["Gallery"] = "Gallery";
})(MegaMenuLayout || (MegaMenuLayout = {}));
export var MegaMenuType;
(function (MegaMenuType) {
  MegaMenuType["Mobile"] = "Mobile";
  MegaMenuType["Desktop"] = "Desktop";
  MegaMenuType["Mimimal"] = "Minimal";
})(MegaMenuType || (MegaMenuType = {}));